import React from "react";
import { compose } from "redux";
import { Field } from "redux-form/immutable";
import { Grid, MenuItem } from "@material-ui/core";

import { generateFormName } from "utils/app.util";
import { SHIFT_TYPES } from "features/planner/planner.constants";
import { shiftTypeToString } from "features/planner/planner.mappers";
import { HELI_REPORT_FORM } from "features/planner/report/report.constants";
import HeliReportRow from "features/planner/report/helicopter/components/HeliReportRow";
import HeliReportColumn from "features/planner/report/helicopter/components/HeliReportColumn";
import TextFieldColumnField from "features/planner/report/helicopter/components/TextFieldColumnField";
import HeliReportClearRow from "features/planner/report/helicopter/components/HeliReportClearRow";

const OffshoreBoundRow = ({ index }) => (
  <HeliReportRow>
    <Grid container item xs alignItems="center">
      <HeliReportColumn xs={true}>
        <Field
          component={TextFieldColumnField}
          name={generateFormName(
            HELI_REPORT_FORM.OFFSHORE_BOUND,
            index,
            HELI_REPORT_FORM.OFFSHORE_ID,
          )}
        />
      </HeliReportColumn>
      <HeliReportColumn xs={2}>
        <Field
          component={TextFieldColumnField}
          name={generateFormName(
            HELI_REPORT_FORM.OFFSHORE_BOUND,
            index,
            HELI_REPORT_FORM.DISPLAY_NAME,
          )}
        />
      </HeliReportColumn>
      <HeliReportColumn xs={true}>
        <Field
          component={TextFieldColumnField}
          name={generateFormName(
            HELI_REPORT_FORM.OFFSHORE_BOUND,
            index,
            HELI_REPORT_FORM.DATE,
          )}
        />
      </HeliReportColumn>
      <HeliReportColumn xs={true}>
        <Field
          component={TextFieldColumnField}
          name={generateFormName(
            HELI_REPORT_FORM.OFFSHORE_BOUND,
            index,
            HELI_REPORT_FORM.CHECK_IN,
          )}
        />
      </HeliReportColumn>
      <HeliReportColumn xs={true}>
        <Field
          component={TextFieldColumnField}
          name={generateFormName(
            HELI_REPORT_FORM.OFFSHORE_BOUND,
            index,
            HELI_REPORT_FORM.HELIPORT,
          )}
        />
      </HeliReportColumn>
      <HeliReportColumn xs={true}>
        <Field
          select
          component={TextFieldColumnField}
          name={generateFormName(
            HELI_REPORT_FORM.OFFSHORE_BOUND,
            index,
            HELI_REPORT_FORM.SHIFT_TYPE,
          )}
        >
          {Object.values(SHIFT_TYPES).map(shiftType => (
            <MenuItem key={shiftType} value={shiftType}>
              {shiftTypeToString(shiftType)}
            </MenuItem>
          ))}
        </Field>
      </HeliReportColumn>
      <HeliReportColumn xs={true}>
        <Field
          component={TextFieldColumnField}
          name={generateFormName(
            HELI_REPORT_FORM.OFFSHORE_BOUND,
            index,
            HELI_REPORT_FORM.SERVICE,
          )}
        />
      </HeliReportColumn>
      <HeliReportColumn xs={true}>
        <Field
          component={TextFieldColumnField}
          name={generateFormName(
            HELI_REPORT_FORM.OFFSHORE_BOUND,
            index,
            HELI_REPORT_FORM.RETURN_DATE,
          )}
        />
      </HeliReportColumn>
      <Grid item>
        <HeliReportClearRow
          index={index}
          type={HELI_REPORT_FORM.OFFSHORE_BOUND}
        />
      </Grid>
    </Grid>
  </HeliReportRow>
);

export default compose()(OffshoreBoundRow);
